import { createAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	CategoryDefault,
	CategoryDetail,
	CreateCategoryAsyncParams,
	GetDetailCategoryAsyncParams,
	GetListCategoryAsyncParams,
	UpdateCategoryAsyncParams,
} from "../type.d";

export interface InitialCategory {
	categoryList: CategoryDetail[];
	categoryDetail: CategoryDetail;
	categoryTotal: number;
}

const initialState: InitialCategory = {
	categoryList: [],
	categoryDetail: CategoryDefault,
	categoryTotal: 0,
};

export const categorySlice = createSlice({
	name: "category",
	initialState,
	reducers: {
		setListCategory(state, action) {
			state.categoryList = action.payload.data;
		},
		setDetailCategory(state, action) {
			state.categoryDetail = action.payload.data;
		},
		setTotalCategory(state, action) {
			state.categoryTotal = 0;
		},
		changeStatusCategory(state, action) {
			const { id, status } = action.payload;
			const index = state.categoryList.findIndex(el => el.id === id);
			state.categoryList[index].status = status;
		},
	},
});

export const {
	setListCategory,
	setDetailCategory,
	setTotalCategory,
	changeStatusCategory,
} = categorySlice.actions;

export const selectListCategory = (state: RootState) =>
	state.category.categoryList;
export const selectDetailCategory = (state: RootState) =>
	state.category.categoryDetail;
export const selectTotalCategory = (state: RootState) =>
	state.category.categoryTotal;

export const getListCategoryAsync = createAction(
	"category/getListCategory",
	(payload: GetListCategoryAsyncParams) => ({
		payload,
	}),
);

export const getDetailCategoryAsync = createAction(
	"category/getDetailCategory",
	(payload: GetDetailCategoryAsyncParams) => ({
		payload,
	}),
);

export const createCategoryAsync = createAction(
	"category/createCategory",
	(payload: CreateCategoryAsyncParams) => ({
		payload,
	}),
);

export const updateCategoryAsync = createAction(
	"category/updateCategory",
	(payload: UpdateCategoryAsyncParams) => ({
		payload,
	}),
);

export default categorySlice.reducer;
